import styled from 'styled-components';

export const StyledText = styled.span`
  margin-left: 14px;
  font-size: 15px;
  color: ${({ theme }) => theme.color.pickledBluewood};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    span {
      color: ${({ theme }) => theme.color.brightTurquoise};
    }
    svg {
      path {
        fill: ${({ theme }) => theme.color.brightTurquoise};
      }
    }
  }
`;
